<ccs-navbar />
<div class="container">
  <div class="row">
    <div class="col col-lg">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>